import { useEffect, useState, useMemo } from 'react';

import styles from './styles.module.scss';

const logoLoading = '/logos/loadingLogo.svg';
const tag = '/icons/tag.png';

interface IProps {
  fast: boolean;
  texts: string[];
  setLoading(loading: boolean): void;
  time: number;
  detran?: string;
}

const LoadingConsult = ({
  fast,
  texts,
  setLoading,
  time,
  detran = '',
}: IProps) => {
  const [timeLimit, setTimeLimit] = useState(time * 80);
  const [timeProgress, setTimeProgress] = useState(0);
  const [progress, setProgress] = useState(0);
  const [message, setMessage] = useState('');
  const [fastProgress, setFastProgress] = useState(false);
  const [overOneMinute, setOverOneMinute] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      if (timeProgress <= timeLimit && (progress <= 0.98 || fastProgress)) {
        setTimeProgress(timeProgress + 1);
        setProgress(timeProgress / timeLimit);
      }

      if (progress >= 0.5) {
        setOverOneMinute(true);
      }
    }, 12.5);

    return () => clearInterval(interval);
  }, [progress, timeProgress, timeLimit, fastProgress]);

  useEffect(() => {
    setFastProgress(fast);
    if (fastProgress) {
      setTimeLimit(2 * 80);
      setTimeProgress(progress * (2 * 80));
    }
  }, [fastProgress, fast, progress]);

  const messages = useMemo(() => {
    const initialProgress = 1 / texts.length;
    const messages = texts.map((text, n) => ({
      text: text,
      textProgress: initialProgress * n,
    }));
    return messages;
  }, [texts]);

  useEffect(() => {
    const messagesFiltered = messages.filter(
      (message) => message.textProgress <= progress,
    );
    setMessage(messagesFiltered[messagesFiltered.length - 1].text);
  }, [messages, progress]);

  useEffect(() => {
    if (progress === 1) {
      setLoading(false);
    }
  }, [progress, setLoading]);

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.logoloading}>
          <img src={logoLoading} alt="" />
        </div>
        <div className={styles.progressContainer}>
          <div className={styles.progressContent}>
            <div className={styles.progressBar}>
              <div className={styles.progressBarTotal} />
              <div
                className={styles.progressBarComplete}
                style={{ width: `${progress * 100}%` }}
              ></div>
              <div
                className={styles.tag}
                style={{ left: `calc(${progress * 100}% - 25px)` }}
              >
                <img src={tag} alt="" />
              </div>
              <div className={styles.progressBarPercents}>
                <span>
                  {new Intl.NumberFormat('pt-BR', {
                    style: 'percent',
                  }).format(progress)}
                </span>
              </div>
            </div>
          </div>
          <div className={styles.progressMessage}>
            <span>{message}</span>
            {detran !== '' && !overOneMinute && (
              <span className={styles.warningMsg}>
                {`As consultas no Detran ${detran} podem levar até 1 minuto. Não feche a janela.`}
              </span>
            )}
            {overOneMinute && !fastProgress && (
              <span className={styles.warningMsg}>
                {`Desculpe, a consulta está demorando um pouco mais que o normal. Não feche a janela.`}
              </span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export { LoadingConsult };
